






























import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import SingleCoup from './singleCoup.vue'

@Component({
  components: {
    SingleCoup,
  },
})
export default class BagPop extends Vue {
  @Prop({ default: () => {} }) publicParams
  @Prop() showBagPop
  @Prop() bagCoupInfos
  @Prop() bagFailList
  @Prop() pageId

  async mounted() {
    await this.$nextTick()
    let app = document.querySelector('.preview-box')
    app.classList.add('stopmove')
  }

  close() {
    let app = document.querySelector('.preview-box')
    app.classList.remove('stopmove')
    this.$emit('update:showBagPop', false)
  }

  updateCoupons() {
    this.$emit('updateCoupons')
  }

  clickEvent() {
    this.$emit('clickEvent')
  }
}
